export default function CustomTimePicker(vnode) {
  let open = false;
  let hour = "12";
  let minute = "00";
  let container;
  let required = vnode.attrs.required || false;

  const handleClickOutside = (e) => {
    if (container && !container.contains(e.target)) {
      open = false;
      m.redraw();
    }
  };

  const toggle = (e) => {
    e.stopPropagation();
    open = !open;
  };

  const selectHour = (h) => {
    hour = h;
    vnode.attrs.onchange?.(`${hour}:${minute}`);
  };

  const selectMinute = (mVal) => {
    minute = mVal;
    vnode.attrs.onchange?.(`${hour}:${minute}`);
  };

  return {
    oncreate(v) {
      container = v.dom;
      document.addEventListener("click", handleClickOutside);
    },
    onremove() {
      document.removeEventListener("click", handleClickOutside);
    },
    view() {
      return m(
        ".position-relative.d-inline-block",
        { oncreate: (v) => (container = v.dom) },
        [
          m("input.form-control.text-center[readonly]", {
            style: "width:120px; cursor:pointer;",
            required: required,
            value: `${hour}:${minute}`,
            onclick: toggle,
          }),
          open &&
          m(
            ".border.rounded.bg-white.shadow.position-absolute.p-2",
            {
              style: "z-index:1000; top:100%; left:0; width:220px;",
              onclick: (e) => e.stopPropagation(),
            },
            [
              m(".d-flex.justify-content-between.mb-2", [
                m("strong.text-secondary.small", "Hour"),
                m("strong.text-secondary.small", "Minute"),
              ]),
              m(".d-flex.justify-content-between", [
                m(
                  "select.form-select.me-2",
                  {
                    style: "width: 100px;",
                    value: hour,
                    onchange: (e) => selectHour(e.target.value),
                  },
                  Array.from({ length: 24 }, (_, i) => {
                    const val = String(i).padStart(2, "0");
                    return m("option", { value: val }, val);
                  })
                ),
                m(
                  "select.form-select",
                  {
                    style: "width: 100px;",
                    value: minute,
                    onchange: (e) => selectMinute(e.target.value),
                  },
                  Array.from({ length: 60 }, (_, i) => {
                    const val = String(i).padStart(2, "0");
                    return m("option", { value: val }, val);
                  })
                ),
              ]),
            ]
          ),
        ]
      );
    },
  };
}